var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.6,
    y: 64,
    style: {
      fill: "#A9D0D3"
    },
    width: 51.2,
    height: 51.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.6,
    y: 166.4,
    style: {
      fill: "#A9D0D3"
    },
    width: 51.2,
    height: 51.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.6,
    y: 371.2,
    style: {
      fill: "#A9D0D3"
    },
    width: 51.2,
    height: 51.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 64,
    style: {
      fill: "#A9D0D3"
    },
    width: 51.2,
    height: 51.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.6,
    y: 268.8,
    style: {
      fill: "#A9D0D3"
    },
    width: 51.2,
    height: 51.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.2,
    y: 422.4,
    style: {
      fill: "#A9D0D3"
    },
    width: 76.8,
    height: 76.8
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#79615B"
    },
    d: "M38.4,499.2V12.8h256v153.6h-89.6c-7.057,0-12.8,5.743-12.8,12.8v320H38.4z M89.6,422.4h51.2v-51.2 H89.6V422.4z M89.6,320h51.2v-51.2H89.6V320z M89.6,217.6h51.2v-51.2H89.6V217.6z M192,115.2h51.2V64H192V115.2z M89.6,115.2h51.2 V64H89.6V115.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 243.2,
    y: 217.6,
    style: {
      fill: "#A9D0D3"
    },
    width: 179.2,
    height: 51.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.2,
    y: 320,
    style: {
      fill: "#A9D0D3"
    },
    width: 179.2,
    height: 51.2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 371.2,
    y: 422.4,
    style: {
      fill: "#FF877F"
    },
    width: 51.2,
    height: 76.8
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9A8984"
    },
    d: "M422.4,499.2v-64c0-7.057-5.743-12.8-12.8-12.8H384c-7.057,0-12.8,5.743-12.8,12.8v64H320v-64 c0-7.057-5.743-12.8-12.8-12.8H256c-7.057,0-12.8,5.743-12.8,12.8v64H192V166.4h281.6v332.8H422.4z M256,320 c-7.057,0-12.8,5.743-12.8,12.8v25.6c0,7.057,5.743,12.8,12.8,12.8h153.6c7.057,0,12.8-5.743,12.8-12.8v-25.6 c0-7.057-5.743-12.8-12.8-12.8H256z M256,217.6c-7.057,0-12.8,5.743-12.8,12.8V256c0,7.057,5.743,12.8,12.8,12.8h153.6 c7.057,0,12.8-5.743,12.8-12.8v-25.6c0-7.057-5.743-12.8-12.8-12.8H256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#573A32"
    },
    d: "M256,384h153.6c14.14,0,25.6-11.46,25.6-25.6v-25.6c0-14.14-11.46-25.6-25.6-25.6H256 c-14.14,0-25.6,11.46-25.6,25.6v25.6C230.4,372.54,241.86,384,256,384z M256,332.8h153.6v25.6H256V332.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#573A32"
    },
    d: "M256,281.6h153.6c14.14,0,25.6-11.46,25.6-25.6v-25.6c0-14.14-11.46-25.6-25.6-25.6H256 c-14.14,0-25.6,11.46-25.6,25.6V256C230.4,270.14,241.86,281.6,256,281.6z M256,230.4h153.6V256H256V230.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#573A32"
    },
    d: "M140.8,51.2H89.6c-7.074,0-12.8,5.726-12.8,12.8v51.2c0,7.074,5.726,12.8,12.8,12.8h51.2 c7.074,0,12.8-5.726,12.8-12.8V64C153.6,56.926,147.874,51.2,140.8,51.2z M128,102.4h-25.6V76.8H128V102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#573A32"
    },
    d: "M256,115.2V64c0-7.074-5.726-12.8-12.8-12.8H192c-7.074,0-12.8,5.726-12.8,12.8v51.2 c0,7.074,5.726,12.8,12.8,12.8h51.2C250.274,128,256,122.274,256,115.2z M230.4,102.4h-25.6V76.8h25.6V102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#573A32"
    },
    d: "M140.8,153.6H89.6c-7.074,0-12.8,5.726-12.8,12.8v51.2c0,7.074,5.726,12.8,12.8,12.8h51.2 c7.074,0,12.8-5.726,12.8-12.8v-51.2C153.6,159.326,147.874,153.6,140.8,153.6z M128,204.8h-25.6v-25.6H128V204.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#573A32"
    },
    d: "M140.8,256H89.6c-7.074,0-12.8,5.726-12.8,12.8V320c0,7.074,5.726,12.8,12.8,12.8h51.2 c7.074,0,12.8-5.726,12.8-12.8v-51.2C153.6,261.726,147.874,256,140.8,256z M128,307.2h-25.6v-25.6H128V307.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#573A32"
    },
    d: "M140.8,358.4H89.6c-7.074,0-12.8,5.726-12.8,12.8v51.2c0,7.074,5.726,12.8,12.8,12.8h51.2 c7.074,0,12.8-5.726,12.8-12.8v-51.2C153.6,364.126,147.874,358.4,140.8,358.4z M128,409.6h-25.6V384H128V409.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#573A32"
    },
    d: "M499.2,486.4h-12.8V179.2c0-14.14-11.46-25.6-25.6-25.6H307.2v-128c0-14.14-11.46-25.6-25.6-25.6 H51.2C37.06,0,25.6,11.46,25.6,25.6v460.8H12.8c-7.074,0-12.8,5.726-12.8,12.8c0,7.074,5.726,12.8,12.8,12.8h486.4 c7.074,0,12.8-5.726,12.8-12.8C512,492.126,506.274,486.4,499.2,486.4z M179.2,179.2v307.2h-128V25.6h230.4v128h-76.8 C190.66,153.6,179.2,165.06,179.2,179.2z M307.2,486.4H256v-51.2h51.2V486.4z M409.6,486.4H384v-51.2h25.6V486.4z M460.8,486.4 h-25.6v-51.2c0-14.14-11.46-25.6-25.6-25.6H384c-14.14,0-25.6,11.46-25.6,25.6v51.2h-25.6v-51.2c0-14.14-11.46-25.6-25.6-25.6H256 c-14.14,0-25.6,11.46-25.6,25.6v51.2h-25.6V179.2h256V486.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPj);
export default __webpack_public_path__ + "static/media/PJ.e4a5805ed8e6b8a5ffccc8508c1c2bcd.svg";
export { ForwardRef as ReactComponent };